export default [
    '$log',
    '$uibModalInstance',
    '$scope',
    '$window',
    ($log, $uibModalInstance, $scope, $window) => {
        const ctrl = {};

        const IMAGE_FOLDER = '/static/images/filter-guide/';

        const steps = [{
            text: 'Познакомьтесь с нашими новыми фильтрами',
            img: IMAGE_FOLDER + 'step_intro.png',
        }, {
            text: 'Меняйте тип объекта и основные параметры прямо в выдаче',
            img: IMAGE_FOLDER + 'step_price.png',
        }, {
            text: 'Быстро и точно настраивайте географию поиска',
            img: IMAGE_FOLDER + 'step_geo.png',
        }, {
            text: 'Уточните детали поиска. Все параметры отобразятся в виде тегов',
            img: IMAGE_FOLDER + 'step_tags.png',
        }, {
            text: 'Удачного поиска!',
            img: IMAGE_FOLDER + 'step_finale.png',
        }];

        ctrl.stepCount = 1;
        ctrl.maxSteps = steps.length;
        ctrl.images = steps.map(s => s.img);

        ctrl.next = () => {
            if (ctrl.stepCount === steps.length) {
                $uibModalInstance.close();
                return;
            }

            ctrl.stepCount++;
            trackStep(ctrl.stepCount);
        };

        ctrl.getButtonText = () =>
            ctrl.stepCount === steps.length ? 'Ок' : 'Далее';

        ctrl.getTitle = () => steps[ctrl.stepCount - 1].text;


        /*
            Google Analytics
        */

        // Открытие модала
        $window.ca('event', {name: 'oldevent', category: 'NewFilters_Tutorial', action: 'Open'});

        // Закрытие модала
        $scope.$on('modal.closing', () => {
            $windowca('event', {name: 'oldevent', category: 'NewFilters_Tutorial', action: 'Close', label: ctrl.stepCount});
        });

        // Просмотр шага
        trackStep(ctrl.stepCount);
        function trackStep(n) {
            $windowca('event', {name: 'oldevent', category: 'NewFilters_Tutorial', action: 'PageView', label: n});
        }

        return ctrl;
    }];



// WEBPACK FOOTER //
// ./src/serp/directives/filter-guide/filter-guide.modal.ctrl.js